import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  public isLoading = new Subject<boolean>();
  public message = new BehaviorSubject<string | null>(null);

  show(message?: string | null) {
    this.message.next(message ?? null);
    this.isLoading.next(true)
  }

  hide() {
    this.isLoading.next(false)
    this.message.next(null);
  }
}
